import { Component, Host, h, Element, Prop, Method, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'lgr-modal',
  styleUrl: 'modal.scss',
  shadow: false,
})
export class Modal {
  @Element() el!: HTMLLgrModalElement;
  /**
   * Open modal
   */
  @Prop({mutable: true}) isOpen: boolean = false;
  /**
   * Button's text
   */
  @Prop() buttonText: string | undefined;
  /**
   * variant: primary, secondary or text
   */
  @Prop({ reflect: true }) buttonVariant?: 'primary' | 'secondary' | 'text' = 'primary';
  /**
   * Modal full size on mobile
   */
  @Prop() fullSize: boolean = false;
  /**
   * size for webform
   */
  @Prop() webformSize: boolean = false;
  /**
   * if enabled, close buttons will disappear.
   */
  @Prop() closeDisabled: boolean = false;
  /**
   * if enabled, close by keyboard disabled.
   */
  @Prop() closeKeyboardDisabled: boolean = false;
  /**
   * When called, this method opens the modal
   */
  @Method()
  async openModal() {
    this.isOpen = true;
  }
  /***
   *
   */
  @Method()
  async closeModalMethod() {
    this.isOpen = false;
    this.modalClosed.emit();
  };
  /**
   *
   */
  @Event() modalClosed!: EventEmitter<string>;

  connectedCallback() {
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleKeyDown.bind(this));
  }

  private handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape' && !this.closeKeyboardDisabled) {
      this.closeModal();
    }
  }

  render() {
    return (
      <Host>
        <div class={{
          'modal': true,
          'is-open': this.isOpen,
          'full-size': this.fullSize
        }}>
          <div class={{
            'modal-content': true,
            'modal-content-webform': this.webformSize
          }}>
            {
              !this.closeDisabled &&
              <lgr-icon tabIndex={0} onClick={this.closeModal} class="close">close</lgr-icon>
            }
            <div class='text-wrapper'>
              <slot name='first-text'></slot>
              <slot name='second-text'></slot>
              <slot></slot>
            </div>
            {
              this.buttonText && !this.closeDisabled &&
              <div class="button-wrapper">
                <lgr-button full-width variant={this.buttonVariant} onClick={this.closeModal}>{this.buttonText}</lgr-button>
                <slot name="second-button"></slot>
              </div>
            }
          </div>
          <div class="modal-layer" onClick={this.closeModal} />
        </div>
      </Host>
    );
  }

  private closeModal = () => {
    if (this.closeDisabled) return;
    this.isOpen = false;
    this.modalClosed.emit();
  };
}
